import React from 'react';
import PropTypes from 'prop-types';
import {TableRowHeader, BaseLevelHeaderStyle} from './style/base_level_header_style';

export const BaseLevelSimpleHeader = ({columns, stickyTopPosition}) => {
	return (
		<TableRowHeader stickyTopPosition={stickyTopPosition}>
			{columns.reportedTime !== undefined && columns.reportedTime !== 0 && (
				<BaseLevelHeaderStyle>
					<span>Reported Time</span>
				</BaseLevelHeaderStyle>
			)}

			{columns.personName !== undefined && columns.personName !== 0 && (
				<BaseLevelHeaderStyle>
					<p>Person</p>
				</BaseLevelHeaderStyle>
			)}

			{columns.projectName !== undefined && columns.projectName !== 0 && (
				<BaseLevelHeaderStyle>
					<p>Project</p>
				</BaseLevelHeaderStyle>
			)}

			{columns.taskName !== undefined && columns.taskName !== 0 && (
				<BaseLevelHeaderStyle>
					<p>Task</p>
				</BaseLevelHeaderStyle>
			)}

			{columns.roleName !== undefined && columns.roleName !== 0 && (
				<BaseLevelHeaderStyle width={166}>
					<p>Role</p>
				</BaseLevelHeaderStyle>
			)}

			{columns.price !== undefined && columns.price !== 0 && (
				<BaseLevelHeaderStyle>
					<p>Price</p>
				</BaseLevelHeaderStyle>
			)}

			{columns.cost !== undefined && columns.cost !== 0 && (
				<BaseLevelHeaderStyle>
					<p>Cost</p>
				</BaseLevelHeaderStyle>
			)}

			{columns.notes !== undefined && columns.notes !== 0 && (
				<BaseLevelHeaderStyle>
					<p>Notes</p>
				</BaseLevelHeaderStyle>
			)}
		</TableRowHeader>
	);
};

BaseLevelSimpleHeader.propTypes = {
	columns: PropTypes.shape({
		reportedTime: PropTypes.bool,
		personName: PropTypes.bool,
		timeRegType: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		timeRegId: PropTypes.bool,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
	}).isRequired,

	stickyTopPosition: PropTypes.number,
};
